import { Dimensions, IAuditedEntity, Quantity } from '@elderbyte/ngx-starter'
import { Instant } from '@js-joda/core'
import { MaterialComponent } from '../orders/work-items/bom/material-component'
import { PackageType } from './types/package-type'

export class NewPackage {
  public static ofWorkBatch(workBatchId: string): NewPackage {
    return new NewPackage(workBatchId)
  }

  constructor(public workBatchId: string) {}
}

interface PackageProduction {
  productionPath: string
  eligibleWorkBatches: string[]
  activeWorkBatches?: string[]
  sourceWorkCenterId?: string
  productionPriority?: number
}

export class Package {
  public id: string

  public number: string

  public typeId: string
  public type: PackageType

  public prodOrderId: string
  public workOrderId: string

  public facility: string

  public state: PackageState
  public dispatchState: ExternalPackageState

  public production?: PackageProduction

  public description: string

  public spec: PackageSpec

  public weight: Quantity // readonly
  public contentWeight: Quantity
  public packagingMaterialWeight: Quantity

  public dimensions: Dimensions
  public longestItemDimensions: Dimensions

  public storageTargetRoot: string
  public location: PackageLocation

  public items: ItemUnitBundle[]
  public containsPartialItems: boolean
  public oneItemExclusive: boolean

  public contentDescription: string

  public packagingItems: PackagingItem[]

  public audit: IAuditedEntity
}

export enum PackageState {
  PREDICTED = 'PREDICTED',

  PREVIEW = 'PREVIEW',

  CONFIRMED = 'CONFIRMED',

  DISPATCHING = 'DISPATCHING',
}

export class ExternalPackageState {
  public state: ExternalPackageState.State

  public stateInfo: string

  public modifiedAt: Instant
}

export namespace ExternalPackageState {
  export enum State {
    UNKNOWN = 'UNKNOWN',
    OPEN = 'OPEN',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
  }
}

export class PackageLocation {
  public storagePath: string
  public checkIn: Instant
}

export class PackageSpec {
  public maxWeight: Quantity
  public maxDimension: Dimensions
}

export class ItemUnitBundle {
  public id: string
  public itemId: string
  public itemNumber: string
  public workBatchId: string
  public product: MaterialComponent

  public totalQuantity: Quantity
  public packagedQuantity: Quantity

  public totalWeight: Quantity
  public weight: Quantity

  public unitDimensions: Dimensions

  public partial: boolean
}

export class PackagingItem {
  constructor(public material: MaterialComponent) {}
}
